module.exports = __webpack_public_path__ + "static/media/SEND.2ac0cb7f.png";